// extracted by mini-css-extract-plugin
module.exports = {"container":"partnership_container__yYiRf","bannerBg":"partnership_bannerBg__13M_V","orderingWrap":"partnership_orderingWrap__FgvRa"};